import { ReactElement } from 'react'
import BoxTitle from './BoxTitle'
import './Box.scss'

interface BoxProps {
  icon: string
  title: string
  color: 'azure' | 'magenta' | 'violet'
  content?: ReactElement
  titleContent?: ReactElement
}

export default function Box(props: BoxProps): ReactElement {
  const { icon, title, color, content, titleContent } = props

  return (
    <>
      <BoxTitle icon={icon} title={title} color={color} titleContent={titleContent} />
      {content && <div className="custom-box">{content}</div>}
    </>
  )
}
